import { Search, Plus, ArrowLeft, PlusCircle } from "lucide-react";
import { ENVIRONMENT } from "../../../environment/environment";
import { Button } from "../ui";

interface IFerramanetasDaListagem {
  textoDaBusca?: string;
  placeholder?: string;
  mostrarInputBusca?: boolean;
  aoMudarTextoDeBusca?: (novoTexto: string) => void;
  mostraBotaoNovo?: boolean;
  textoBotaoNovo?: string;
  aoClicarBotaoNovo?: () => void;
  mostraBotaoFiltro?: boolean;
  textoBotaoFiltro?: string;
  aoClicarBotaoFiltro?: () => void;
  mostraBotaoVoltar?: boolean;
  textoBotaoVoltar?: string;
  aoClicarBotaoVoltar?: () => void;
  mostrarBotaoAdicional?: boolean;
  textoBotaoAdicional?: string;
  aoClicarBotaoAdicional?: () => void;
  /** Exibe um seletor de ano (usado, por exemplo, no filtro do Dashboard) */
  mostrarSeletorAno?: boolean;
  anoSelecionado?: number;
  aoMudarAno?: (ano: number) => void;
  /** Lista de anos disponíveis no seletor. Por padrão, últimos 5 anos até o atual. */
  anosDisponiveis?: number[];
}

export function FerramanetasDaListagem({
  textoDaBusca = "",
  mostrarInputBusca = false,
  aoMudarTextoDeBusca,
  mostraBotaoNovo = true,
  textoBotaoNovo = "Novo",
  aoClicarBotaoNovo,
  mostraBotaoFiltro = false,
  textoBotaoFiltro = "Filtros Avançados",
  aoClicarBotaoFiltro,
  placeholder = ENVIRONMENT.INPUT_DE_BUSCA,
  mostraBotaoVoltar = false,
  aoClicarBotaoVoltar,
  textoBotaoVoltar,
  mostrarBotaoAdicional = false,
  aoClicarBotaoAdicional,
  textoBotaoAdicional = "",
  mostrarSeletorAno = false,
  anoSelecionado,
  aoMudarAno,
  anosDisponiveis,
}: IFerramanetasDaListagem) {
  const anoAtual = new Date().getFullYear();
  const anos =
    anosDisponiveis ?? Array.from({ length: 5 }, (_, i) => anoAtual - i);

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-xl bg-white p-2.5 shadow-card dark:bg-slate-800 md:flex-nowrap">
      <div className="w-full md:w-2/5">
        {mostrarInputBusca && (
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder={placeholder}
              value={textoDaBusca}
              onChange={(e) => aoMudarTextoDeBusca?.(e.target.value)}
              className="w-full rounded-lg border border-slate-300 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30 dark:border-slate-600 dark:bg-slate-900 dark:text-white"
            />
          </div>
        )}
      </div>

      <div className="flex w-full flex-wrap items-center justify-end gap-2 md:w-3/5">
        {mostrarSeletorAno && (
          <select
            value={anoSelecionado ?? anoAtual}
            onChange={(e) => aoMudarAno?.(Number(e.target.value))}
            className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200"
          >
            {anos.map((ano) => (
              <option key={ano} value={ano}>
                {ano}
              </option>
            ))}
          </select>
        )}

        {mostraBotaoFiltro && (
          <Button variant="secondary" endIcon={<Search className="h-4 w-4" />} onClick={aoClicarBotaoFiltro}>
            {textoBotaoFiltro}
          </Button>
        )}

        {mostraBotaoNovo && (
          <Button variant="primary" endIcon={<Plus className="h-4 w-4" />} onClick={aoClicarBotaoNovo}>
            {textoBotaoNovo}
          </Button>
        )}

        {mostraBotaoVoltar && (
          <Button variant="secondary" endIcon={<ArrowLeft className="h-4 w-4" />} onClick={aoClicarBotaoVoltar}>
            {textoBotaoVoltar}
          </Button>
        )}

        {mostrarBotaoAdicional && (
          <Button variant="outline" startIcon={<PlusCircle className="h-4 w-4" />} onClick={aoClicarBotaoAdicional}>
            {textoBotaoAdicional}
          </Button>
        )}
      </div>
    </div>
  );
}

